export const insightSortOptions = [
    { field: 'name', label: 'Provider name' },
    { field: 'googleRating', label: 'Google rating' },
    { field: 'service', label: 'Service' },
];

export const emptyInsightFilters = { service: '' };

export const getMobileInsightResults = (insights, search, filters, sort) => {
    const query = search.trim().toLowerCase();
    const results = insights.filter(insight => {
        const matchesSearch = !query || [insight.name, insight.service, insight.url, insight.description, insight.providerUrl]
            .some(value => String(value || '').toLowerCase().includes(query));
        const matchesService = !filters.service || insight.service === filters.service;
        return matchesSearch && matchesService;
    });
    if (!sort.field) return results;
    const value = insight => {
        const raw = insight[sort.field];
        if (raw === null || raw === undefined || raw === '') return null;
        if (sort.field === 'googleRating') return Number.isFinite(Number(raw)) ? Number(raw) : null;
        return String(raw).trim().toLowerCase();
    };
    return results.sort((a, b) => {
        const left = value(a);
        const right = value(b);
        // Unknown values stay last in either direction.
        if (left === null) return right === null ? 0 : 1;
        if (right === null) return -1;
        const comparison = typeof left === 'number' ? left - right : left.localeCompare(right);
        return sort.direction === 'desc' ? -comparison : comparison;
    });
};
